import { Pause, Play, RotateCcw } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'

interface Props {
  src: string
  initialPosition?: number
  onPosition?: (seconds: number) => void
}

function format(seconds: number) {
  if (!Number.isFinite(seconds)) return '0:00'
  const min = Math.floor(seconds / 60)
  return `${min}:${Math.floor(seconds % 60).toString().padStart(2, '0')}`
}

export function AudioPlayer({ src, initialPosition = 0, onPosition }: Props) {
  const ref = useRef<HTMLAudioElement>(null)
  const [playing, setPlaying] = useState(false)
  const [current, setCurrent] = useState(initialPosition)
  const [duration, setDuration] = useState(0)

  useEffect(() => {
    const audio = ref.current
    if (audio && initialPosition > 0 && audio.currentTime < 1) audio.currentTime = initialPosition
  }, [initialPosition])

  const toggle = async () => {
    const audio = ref.current
    if (!audio) return
    if (audio.paused) await audio.play(); else audio.pause()
  }

  return <div className="audio-player">
    <audio ref={ref} src={src} preload="metadata" onPlay={() => setPlaying(true)} onPause={() => { setPlaying(false); onPosition?.(current) }} onLoadedMetadata={(event) => setDuration(event.currentTarget.duration)} onTimeUpdate={(event) => setCurrent(event.currentTarget.currentTime)} />
    <button className="player-main" onClick={toggle} aria-label={playing ? 'Pausar' : 'Reproduzir'}>{playing ? <Pause /> : <Play fill="currentColor" />}</button>
    <div className="player-track">
      <input aria-label="Posição do áudio" type="range" min="0" max={duration || 1} value={current} onChange={(event) => { const value = Number(event.target.value); if (ref.current) ref.current.currentTime = value; setCurrent(value) }} />
      <div><span>{format(current)}</span><span>{format(duration)}</span></div>
    </div>
    <button className="player-reset" onClick={() => { if (ref.current) ref.current.currentTime = Math.max(0, current - 15) }} aria-label="Voltar 15 segundos"><RotateCcw /><small>15</small></button>
  </div>
}
